import React from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";

const PatchNotesModal = ({modalOpen, onClose}) => {

    const handleClose = (_, reason) => {
        // if (reason === "backdropClick" || reason === "escapeKeyDown") {
        //     return;
        // }
        onClose();
    };

    return (
        <>
            <Dialog
                open={modalOpen}
                onClose={handleClose}
            >
                <DialogTitle
                    id="form-dialog-title"
                    style={{position: "relative", paddingRight: 48}}
                >
                    {"FAQ"}
                    <IconButton
                        size="small"
                        onClick={handleClose}
                        aria-label="Fechar"
                        style={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                        }}
                    >
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers style={{fontSize: '13pt', lineHeight: '1.6', color: '#333'}}>
                    <div>
                        <h3 style={{marginBottom: '0.5rem', color: '#1976d2'}}>
                            <span role="img" aria-label="megafone">📢</span> Notas de Atualização
                        </h3>

                        <p>Fique por dentro das mais recentes atualizações do nosso sistema!</p>

                        <p>
                            <strong>
                                <span role="img" aria-label="link">🔗</span>{' '}
                                <a
                                    href="https://faq.whatscontabil.com.br/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{color: '#1976d2', textDecoration: 'none'}}
                                >
                                    Clique aqui
                                </a>
                            </strong> e acesse agora mesmo para descobrir todas as novidades disponíveis para você.
                        </p>

                        <p>
                            <span role="img" aria-label="documento">📄</span>{' '}
                            <strong>Documentação:</strong>&nbsp;
                            <a
                                href="https://faq.whatscontabil.com.br/docs/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{color: '#1976d2', fontWeight: 'bold', textDecoration: 'none'}}
                            >
                                Visualizar
                            </a>
                        </p>

                        <p style={{marginTop: '4rem', fontStyle: 'italic', fontSize: '11pt'}}>
                            <span role="img" aria-label="pacote">📦</span> Versão:&nbsp;<b>v7.1.4</b>
                        </p>
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={handleClose}
                        color={"secondary"}
                        // disabled={loading}
                        variant={"outlined"}
                    >
                        {"Fechar"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PatchNotesModal;
